import { jwtDecode, JwtPayload } from "jwt-decode";

import { User } from "./models/User";

export const buildUserFromAccessToken = (
  accessToken: string
): undefined | User => {
  const decodedToken: JwtPayload = jwtDecode(accessToken);

  const keys = Object.keys(decodedToken);

  const userId = keys.includes("sub") ? decodedToken["sub"] : undefined;

  if (!userId) {
    return undefined;
  }

  const userName = keys.includes("name") ? decodedToken["name"] : "";
  const userRoles = keys.includes("roles") ? decodedToken["roles"] : [];

  return new User(userId, userName, userRoles);
};
